import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Home from '../home';
import Layout from '../../Layout/Layout';
import { creatUserPUBToken } from '../../auth';
import { getTokenOpportunities } from '../../auth/apiRoleTokens';
import { tokenText } from './tokenText';
import './roleTokens.css';

export const myQrDestination = (result, token) => {
  const roles = ['Seller', 'Provider'].filter(role => result?.opportunities?.includes(role));
  if (roles.length === 1) {
    return { to: `/user-step?t=${encodeURIComponent(token)}&role=${encodeURIComponent(roles[0])}` };
  }
  if (roles.length === 2) {
    return { to: '/', state: { showPromotionChoice: true, promotionRoles: roles } };
  }
  return { to: '/' };
};

export default function PromotionEntry({ infoSource }) {
  const { token } = useParams();
  const navigate = useNavigate();
  const t = tokenText(infoSource);
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');
  useEffect(() => {
    let active = true; setResult(null); setError('');
    getTokenOpportunities(token).then(data => {
      if (!active) return;
      // Attribution is persisted only after the backend has validated the
      // owner, live token, switches, expirations and capacities.
      try { creatUserPUBToken(token, () => {}); } catch (_) { /* storage may be unavailable */ }
      if (data?.type === 'MY_QR_CODE') {
        const destination = myQrDestination(data, token);
        navigate(destination.to, { replace: true, state: destination.state });
        return;
      }
      setResult(data);
    }).catch(error => {
      if (!active) return;
      setError(error.code || 'TOKEN_INVALID');
      // Fail closed: an unverifiable QR never enables a promotion and never
      // leaves the visitor on a blank/error-only page.
      navigate('/', { replace: true });
    });
    return () => { active = false; };
  }, [navigate, token]);
  // Existing ordinary Simple Promotion keeps its Home/referral flow.
  if (result && result.opportunities?.every(role => role === 'simple')) return <Home infoSource={infoSource} />;
  return <Layout infoSource={infoSource} title={t('myQr')}>
    <div className="container role-token-panel">
      <h3>{result?.title || t('myQr')}</h3>
      {!result && !error && <p role="status">{t('loading')}</p>}
      {error && <p role="alert" className="alert alert-danger">{t(error)}</p>}
    </div>
  </Layout>;
}
